module.exports = __webpack_public_path__ + "img/linkedin-icon.463b704c.svg";